export default function Marquee() {
  const items = [
    "Transporte Escolar",
    "Traslados Corporativos",
    "Transfers Aeropuerto",
    "Circuitos Turisticos",
    "Eventos Especiales",
    "Peregrinaciones",
    "Viajes Internacionales",
    "Artistas & Bandas",
  ];

  const repeated = [...items, ...items, ...items, ...items];

  return (
    <section className="bg-[#D0162A] py-4 overflow-hidden" data-testid="marquee-section">
      <div className="marquee-track">
        {repeated.map((item, i) => (
          <span
            key={i}
            className="inline-flex items-center px-8 text-white font-heading text-xl md:text-2xl uppercase tracking-[0.15em] whitespace-nowrap"
          >
            {item}
            <span className="mx-6 w-2 h-2 bg-white/40 rotate-45 inline-block" />
          </span>
        ))}
      </div>
    </section>
  );
}
